export default "__VITE_ASSET__0caabcda__"